import { reduce } from 'lodash';
import jobapi from '@enums/jobapi';
import extractTypes from '@enums/extract-types';

function reports({ extracts, reportType }) {
  return reduce(
    extracts,
    (result, e) => {
      if (e.extractType === reportType) {
        let extractType = null;
        let additionalOutputParams = {};
        if (
          [extractTypes.HASU, extractTypes.AOC, extractTypes.INTEGRATION].includes(e.extractType)
        ) {
          extractType = 'compoundExtract';

          additionalOutputParams = {
            blobId: e.blobId,
            extractSettingsId: e.extractSettingsId,
          };
        } else {
          switch (e.extractType) {
            case extractTypes.STORE_EXECUTION:
              extractType = 'storeExecutionExtracts';
              break;
            case extractTypes.FURNITURE:
              extractType = 'furnitureExtract';
              break;

            default:
              extractType = 'extractsGeneration';
              break;
          }
        }

        const status =
          e.jobs && e.jobs[extractType]
            ? jobapi.jobStatusesIconsMappings[e.jobs[extractType].status]
            : jobapi.jobStatusesIconsMappings[jobapi.jobStatuses.failed];

        result.push({
          filenameOnDownload: e.filenameOnDownload,
          fileId: e.fileId,
          extractType: e.extractType,
          extractDatetime: e.extractDatetime,
          status,
          originalJobStatus: 'finished',
          ...additionalOutputParams,
        });
      }

      return result;
    },
    []
  );
}

export default { reports };
